<template>
  <div class="row">

    <div class="col-12 filter_box_container">

      <div v-for="(searchFilter, searchFiltersIndex) in searchFilters" :key="searchFiltersIndex">

        <div v-if="Array.isArray(searchFilter) && searchFilter.length > 0" class="float-left">

          <div v-for="(filterVal, filterIndex) in searchFilter" :key="filterIndex" class="float-left">
            <p class="float-left filter_box mt-0 text-capitalize" :data-filterValue="filterVal" :data-filterKey="filterIndex">
              {{ getFilterDisplayName(searchFiltersIndex) }}<span v-if="getFilterDisplayName(searchFiltersIndex).length > 0">: </span>{{ filterVal }} <span v-on:click="clearFilter" :data-el-filter-index="searchFiltersIndex" :data-value="filterVal" :data-key="filterIndex" class="clear_filter">X</span>
            </p>
          </div>
        </div>

        <div v-if="!ignoreSearchFields.includes(searchFiltersIndex)" class="float-left">
          <div class="float-left" v-if="!Array.isArray(searchFilter) && typeof (searchFilter) !== 'undefined' && searchFilter !== false">
            <p class="filter_box mt-0 text-capitalize" :data-filterValue="searchFiltersIndex" :data-filterKey="searchFilter">
              {{ getFilterDisplayName(searchFiltersIndex) }}<span v-if="searchFilter !== true && searchFilter !== '1'">: {{ formatFilterDisplayVal(searchFiltersIndex, searchFilter) }} </span> <span class="clear_filter" v-on:click="clearFilter" :data-value="searchFilter" :data-key="searchFiltersIndex">X</span>
            </p>
          </div>
        </div>

      </div>
      <div v-if="countSearchFilters(searchFilters) > 1" class="float-left">
        <p class="filter_box float-left border-danger mt-0" v-on:click="clearFilter">Clear Filters <span class="clear_filter" data-key="clear_all">X</span></p>
      </div>
    </div>
  </div>
</template>

<script>
// import vuex
import { mapState } from 'vuex'

export default {
  name: 'SearchCrumbs',
  props: {
    queryPopulated: Boolean
  },
  data () {
    return {
      ignoreSearchFields: [
        'sortBy',
        'sortType',
        'page',
        'viewFormat'
      ]
    }
  },
  computed: {
    ...mapState(['searchFilters', 'totalNumCars', 'stockType'])
  },
  methods: {
    getFilterDisplayName (filter) {
      switch (filter) {
        case 'gen_body_type':
          return 'Body Type'
        case 'body_type':
          return 'Body Type'
        case 'bodyType':
          return 'Body Type'
        case 'show_specials':
          return 'Specials'
        case 'certified':
          return 'Certified'
        case 'fresh':
          return 'Fresh on the Lot'
        case 'keyword':
          return 'Search'
        case 'startPrice':
          return 'Min Price'
        case 'endPrice':
          return 'Max Price'
        case 'status_group':
          return ''
        default:
          return filter
      }
    },
    formatFilterDisplayVal (filterName, filterVal) {
      switch (filterName) {
        case 'startPrice':
          return '$' + filterVal.toLocaleString()
        case 'endPrice':
          return '$' + filterVal.toLocaleString()
        case 'fresh':
          return ''
        case 'show_specials':
          return ''
        default:
          return filterVal
      }
    },
    /**
     * Clear searchFilter with breadcrumb
     */
    clearFilter (el) {
      // what's the searchFilter and index to remove?
      var elKey = el.target.dataset.key // 0
      var elFilterIndex = el.target.dataset.elFilterIndex // make

      this.searchFilters.page = undefined

      if (elKey === 'clear_all') {
        this.$root.resetSearchFilters()
        this.$root.pushToRouter(this.$route.name, [])
        return
      }

      // check if searchFilter is an array
      if (Array.isArray(this.searchFilters[elFilterIndex])) {
        // if key is make, remove all models associated with said make
        if (elFilterIndex === 'make' && this.searchFilters.model.length > 0) {
          // get all models for this make
          this.$root._.filter(this.$store.state.cars, car => {
            if (car.make === this.searchFilters[elFilterIndex][elKey]) {
              for (var modelKey in this.searchFilters.model) {
                var modelVal = this.searchFilters.model[modelKey]
                if (car.model === modelVal) {
                  this.searchFilters.model.splice(modelKey, 1)
                }
              }
            }
          })
        }

        // remove the select item from the specified array within the searchFilters Object
        this.searchFilters[elFilterIndex].splice(elKey, 1)
      } else {
        // is not an array
        // remove the select item from the specified array within the searchFilters Object
        this.searchFilters[elKey] = undefined
      }

      // store our searchFilters in state
      this.$store.dispatch('storeSearchFilters', this.searchFilters)

      // push our new url to router
      this.$root.pushToRouter(this.$route.name, this.searchFilters)
    },
    countSearchFilters (searchFilters) {
      var totalSelectedFilters = 0
      var notPopFields = this.$root.notPopFields

      for (var searchFilter in searchFilters) {
        if (typeof (searchFilters[searchFilter]) !== 'undefined' && !this.$root._.includes(notPopFields, searchFilter)) {
          if (Array.isArray(searchFilters[searchFilter])) {
            if (searchFilters[searchFilter].length > 0) {
              totalSelectedFilters += searchFilters[searchFilter].length
              if (totalSelectedFilters > 1) {
                return 2
              }
            }
          } else {
            totalSelectedFilters += 1
            if (totalSelectedFilters > 1) {
              return totalSelectedFilters
            }
          }
        }
      }
      return totalSelectedFilters
    }
  }
}
</script>

<style>

</style>
